export default {
  pageTitle: 'Home',
  metaDescription: 'PT TEF is an Indonesian fabricator of pressure vessels, heat exchangers and industrial equipment using special materials for Oil & Gas, Petrochemical and Power industries.',
  videoNotSupported: 'Your browser does not support the video tag.',
  counters: {
    project: 'PROJECT',
    countriesExport: 'COUNTRIES EXPORT',
    typeOfMaterials: 'TYPE OF MATERIALS',
    customers: 'CUSTOMERS',
  },
  oneStopSolutions: {
    title: 'One Stop Solutions',
    description:
      'TEF is highly experienced in fabricating products using stainless steel, nickel-based alloys, titanium, and other exotic materials. Our expertise ensures durability, precision, and compliance with international standards.',
    fabrication: {
      title: 'Fabrication Solutions',
      description: 'We manufacture a wide range of industrial equipment, including: ......',
      readMore: 'Read more',
    },
    reconditioning: {
      title: 'Reconditioning & Technical Services',
      description: 'Apart from new fabrication, we offer maintenance and reconditioning....',
      readMore: 'Read more',
    },
  },
  pioneers: {
    title: 'We are pioneers of fabrication <br> with special materials',
    description:
      'With a strong commitment to engineering excellence, consulting expertise, advanced welding techniques, and special materials handling, TEF continuously innovates to meet the ever-evolving demands of the industry.',
  },
  gallery: {
    title: 'Gallery of our work',
    tabs: {
      machine: 'Machine',
      area: 'Area',
      worker: 'Worker',
    },
  },
  news: {
    title: 'Latest News and Blogs',
    subtitle: 'Stay informed with the latest updates and insights from PT TEF',
    readMore: 'READ MORE',
    moreButton: 'News & Other Blogs',
  },
  clients: {
    title:
      'We take pride in delivering quality products that satisfy our customers, with our <br> success supported by the trust of customers, employees, and communities.',
  },
  moto: {
    title: 'START',
    subtitle: 'as TOKKI Group watchword',
    skillUp: { word: 'Skill-up', desc: 'We will try to improve more the level of individual technology upgrade.' },
    timely: { word: 'Timely', desc: 'We will strive to supply necessary document, materials and products in a timely manner.' },
    active: { word: 'Active', desc: "We will breakway from waiting for instructions and taking proactive stance for work." },
    responsibility: { word: 'Responsibility', desc: 'We will responsibility for our work.' },
    try: { word: 'Try', desc: "We are not satisfied with the current situation and will try new things. <br> We will act first and we don't look for excuses as to why we can't do something." },
  },
};
